import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['nestBrown', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-1.5,-1h1v0.5h-1zM0.5,-1h1.5v0.5h-1.5zM0.5,-0.5h1v1.5h-1zM-1.5,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'appleRed', d: 'M0,-2h0.5v0.5h-0.5zM-1.5,-1.5h1v0.5h-1zM0.5,-1.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['appleRed', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M-1,-2h0.5v0.5h-0.5zM0.5,-2h1v0.5h-1zM1,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['pearGreen', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M-0.5,-1.5h1v1h-1z',
    },
    { paint: 'nestBrown', d: 'M-2,-1h0.5v0.5h-0.5zM-1.5,-0.5h2v1h-2zM-1,0.5h1.5v0.5h-1.5z' },
  ],
  pixels: 36,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: [
        ['nestBrown', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-1.5,-1h1v0.5h-1zM0.5,-1h1.5v0.5h-1.5zM0.5,-0.5h1v1.5h-1zM-1.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'appleRed',
      d: 'M-1,-2.5h1v0.5h-1zM-0.5,-2h0.5v0.5h-0.5zM-1.5,-1.5h1v0.5h-1zM0.5,-1.5h0.5v0.5h-0.5zM1.5,0h0.5v0.5h-0.5zM2.5,0h0.5v0.5h-0.5zM1.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['appleRed', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M0,-2.5h0.5v0.5h-0.5zM-1,-2h0.5v0.5h-0.5zM0,-2h1.5v0.5h-1.5zM1,-1.5h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['pearGreen', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M0,-3h0.5v0.5h-0.5zM-0.5,-1.5h1v1h-1z',
    },
    { paint: 'nestBrown', d: 'M-2,-1h0.5v0.5h-0.5zM-1.5,-0.5h2v1h-2zM-1,0.5h1.5v0.5h-1.5z' },
  ],
  pixels: 47,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: [
        ['haybale', 0.55],
        ['nestBrown', 0.45],
      ],
      d: 'M-1,-3h1.5v0.5h-1.5zM-1.5,-2.5h2.5v0.5h-2.5zM-1.5,-2h0.5v0.5h-0.5zM1,-2h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['nestBrown', 0.65],
        ['trunk', 0.35],
      ],
      d: 'M-1,-1h0.5v0.5h-0.5zM0.5,-1h1.5v0.5h-1.5zM0.5,-0.5h1v1.5h-1zM-1.5,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'appleRed', d: 'M0,-2h0.5v0.5h-0.5zM-1.5,-1.5h1v0.5h-1zM0.5,-1.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['appleRed', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M-1,-2h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM1,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['pearGreen', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M-0.5,-1.5h1v1h-1z',
    },
    { paint: 'nestBrown', d: 'M-2,-1h1v0.5h-1zM-1.5,-0.5h2v1h-2zM-1,0.5h1.5v0.5h-1.5z' },
    {
      paint: [
        ['fallenLeafGold', 0.7],
        ['trunk', 0.3],
      ],
      d: 'M-2.5,0.5h1v0.5h-1z',
    },
  ],
  pixels: 47,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
